import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const BetaSignup = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Load HubSpot script if not already loaded
    const existingScript = document.querySelector('script[src*="hsforms.net/forms/embed/243149396.js"]');
    
    if (!existingScript) {
      const script = document.createElement('script');
      script.src = 'https://js-na2.hsforms.net/forms/embed/243149396.js';
      script.defer = true;
      document.head.appendChild(script);
    }
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50">
      <Header />
      
      <main className="container mx-auto px-4 pt-24 pb-16">
        <Button
          variant="ghost"
          onClick={() => navigate('/')}
          className="mb-8"
        >
          <ArrowLeft className="mr-2 h-4 w-4" />
          Back to Home
        </Button>

        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-8">
            <h1 className="text-3xl md:text-4xl font-bold text-careblue-800 mb-3">
              Join the CountedCare Beta
            </h1>
            <p className="text-muted-foreground">
              Be among the first family caregivers to try CountedCare and help shape what we build next.
            </p>
          </div>
          <div className="bg-white rounded-2xl shadow-lg p-8">
            <div 
              className="hs-form-frame" 
              data-region="na2" 
              data-form-id="5509d05e-6982-4afa-8188-177f04c38910" 
              data-portal-id="243149396"
            />
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default BetaSignup;
